import { HttpClient } from '@angular/common/http';
import { IAppResultFile } from '@app/core/model/appresults/appresult-file';
import { BsApiEndPoints } from '@app/core/services/bs-api/endpoints';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { SiteNavigationLinksService } from '@app/core/services/site-navigation/site-navigation-links.service';
import { DataTableUtilities } from '@app/core/utilities/data-table-utilities';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import { RadLinkRendererComponent } from '@app/shared/cell-renderers/rad-link-renderer/rad-link-renderer.component';
import { AppResultFileSearchColumnFields, AppResultFileSearchGridOptionsFormatter } from '@app/search/gridOptions/app-result-file-search-grid-options-formatter';
import { OverrideColumnDefinition, OverrideColumnParameters } from '@app/search/gridOptions/search-grid-options-formatter';

export class AppResultFileChooserGridOptionsFormatter extends AppResultFileSearchGridOptionsFormatter {
  constructor(
    public resourceDictionaryService: SearchResourceDictionaryService,
    public bsshDatePipe: BsshDatePipe,
    public siteNavigationLinksService: SiteNavigationLinksService,
    public http: HttpClient
  ) {
    super(resourceDictionaryService, bsshDatePipe, http);
  }

  protected getOverrideColumnParameters(): OverrideColumnParameters<AppResultFileSearchColumnFields> {
    const inclusiveColumns: AppResultFileSearchColumnFields[] = [
      AppResultFileSearchColumnFields.Name,
      AppResultFileSearchColumnFields.Path,
      AppResultFileSearchColumnFields.FileType,
      AppResultFileSearchColumnFields.AppResult,
      AppResultFileSearchColumnFields.Project,
      AppResultFileSearchColumnFields.Analysis,
      AppResultFileSearchColumnFields.Size,
      AppResultFileSearchColumnFields.Created,
    ];

    const overrideColumnDefinitions: OverrideColumnDefinition<AppResultFileSearchColumnFields>[] = [
      {
        headerName: 'Name',
        colId: AppResultFileSearchColumnFields.Name,
        sortable: false,
        flex: 4,
        minWidth: 300,
        showAlways: true,
        cellRendererFramework: RadLinkRendererComponent,
        cellRendererParams: (params) => {
          if (params.data) {
            const resource: IAppResultFile = this.resourceDictionaryService.getSearchResultResource(params.data, this.resourceType);
            const fileContainerPath = BsApiEndPoints.getAppResultFileRoute(resource);

            const tooltipText = !this.isRowSelectable(params.node) ? this.getUnselectableRowMessage(params.node) : null;
            const cellRendererParams = DataTableUtilities.getRadLinkParams(
              resource.Name,
              fileContainerPath,
              tooltipText,
              null,
              60
            );

            return cellRendererParams;
          } else {
            return {};
          }
        },
      }
    ];

    return {
      inclusiveColumns,
      overrideColumnDefinitions
    };
  }
}